module.exports = __webpack_public_path__ + "static/media/Week 2 Wednesday.0ff30b78.png";